/**
 * Calendar store.
 *
 */

import { Module, getModule } from 'vuex-module-decorators';

import store from '@/store';
import PageBaseModule from '@/store/page';
import PageEntity from '@/store/pageEntity';

import { Calendar } from '@/models/calendar';
import { Filter } from '@/types/filter/filter';

import FilterModel from './filterModel';
import CalendarFilter from './filterEntity';

export const MODULE_NAME = Calendar.moduleName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class CalendarModule extends PageBaseModule {
    filter: Filter;

    constructor(module: CalendarModule) {
        super(module);

        const page = new PageEntity();
        page.setModuleName(Calendar.moduleName);
        page.setTitle(Calendar.listTitle);
        page.setTitleAdd(Calendar.createTitle);
        page.values.actionPagination = 'calendar/updatePage';
        page.values.actionPageAmountItems = 'calendar/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${Calendar.moduleName}_edit`;
        this.pageSettings.routeParam = `${Calendar.moduleName}Id`;

        const filter = new FilterModel();
        this.filter = getModule(CalendarFilter);
        this.filter.setFilterName('calendarFilter');
        this.filter.setTemplateClassName('template-lg');
        this.filter.setFilterModel(filter.filterModel);
        this.filter.setFilterHandlers(filter.filterHandlers);
    }

    get doctorId() {
        return this.filter.filterSettings.filterModel.doctor.current?.id ?? 0;
    }
 }
 
 export default getModule(CalendarModule);
 